import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  toggleFinishCallModal: `${NAMESPACE}_CHAT_TOGGLE_FINISH_MODAL`,
  toggleReassignCallModal: `${NAMESPACE}_CHAT_TOGGLE_REASSIGN_MODAL`,

  updateTicketResolutions: `${NAMESPACE}_CHAT_UPDATE_TICKET_RESOLUTIONS`,
  updateActiveTicket: `${NAMESPACE}_CHAT_UPDATE_ACTIVE_TICKET`,

  submitFinishCall: `${NAMESPACE}_CHAT_SUBMIT_FINISH_CALL`,
  submitReassignCall: `${NAMESPACE}_CHAT_SUBMIT_REASSIGN_CALL`,
  submitAcceptCall: `${NAMESPACE}_CHAT_SUBMIT_ACCEPT_CALL`,

  seeTicketInWindow: `${NAMESPACE}_CHAT_SEE_TICKET_IN_WINDOW`
};

export const actionCreators = {
  /** Chat ticket modals actions */
  toggleFinishCallModal: (payload) => ({ type: actions.toggleFinishCallModal, payload }),
  toggleReassignCallModal: (payload) => ({ type: actions.toggleReassignCallModal, payload }),
  /** Ticket resolutions */
  updateTicketResolutions: (payload) => ({ type: actions.updateTicketResolutions, payload }),

  updateActiveTicket: (payload) => ({ type: actions.updateActiveTicket, payload }),
  /** Actions after receive a ticket */
  submitFinishCall: (payload) => ({ type: actions.submitFinishCall, payload }),
  submitReassignCall: (payload) => ({ type: actions.submitReassignCall, payload }),
  submitAcceptCall: (payload) => ({ type: actions.submitAcceptCall, payload }),

  addNewTicketNotification: (payload) => ({ type: actions.addNewTicketNotification, payload }),

  seeTicketInWindow: (payload) => ({ type: actions.seeTicketInWindow, payload })
};

export default {
  actions,
  actionCreators
};
